<template>
  <div>
    <transition name="modal">
      <div :class="{ modal: true, in: show }" @click="close" v-show="show">
        <div class="modal-dialog">
          <div class="modal-content" @click.stop><slot></slot></div>
        </div>
      </div>
    </transition>

    <div class="modal-backdrop in" v-show="show"></div>
  </div>
</template>

<script>
export default {
  name: 'Modal',
  props: ['show'],
  methods: {
    close: function() {
      this.$emit('close');
    }
  },
  mounted: function() {
    document.addEventListener('keydown', e => {
      if (this.show && e.keyCode == 27) {
        this.close();
      }
    });
  },
  watch: {
    show: function() {
      if (this.show) {
        document.body.classList.add('model-open');
      } else {
        document.body.classList.remove('model-open');
      }
    }
  }
};
</script>

<style lang="scss">
body.model-open {
  overflow: hidden;
}
</style>

<style lang="scss" scoped>
.modal {
  display: flex;
  justify-content: center;
  position: fixed;
  top: 0;
  right: 0;
  overflow: hidden;
  bottom: 0;
  left: 0;
  outline: 0;
  z-index: 9101;
  background-color: transparent;
  max-width: 100%;

  .model-open & {
    overflow-x: hidden;
    overflow-y: auto;
  }
}

.modal-dialog {
  position: relative;
  margin: auto;
  width: 95%;
  align-self: flex-start;
  max-width: 1536px;
  transform: scale(0.8);
  opacity: 0;
  transition: all 0.3s ease-in-out;
  transition-delay: 0.2s;

  .in & {
    transform: scale(1);
    opacity: 1;
  }
}

.modal-content {
  position: relative;
  box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);
  background-clip: padding-box;
  outline: 0;

  color: #000;
  background-color: #fff;
  border-radius: 0;
  border: none;
  box-shadow: none;

  @media only screen and (min-width: 1000px) {
    width: 60%;
    left: 20%;
    right: 20%;
  }
}

.modal-backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9100;
  background-color: #000;
  opacity: 0;
  filter: alpha(opacity=0);
  transition: opacity 0.3s ease-in-out;

  &.in {
    opacity: 0.75;
    filter: alpha(opacity=75);
  }
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  transform: scale(1.1);
}
</style>
